import { FormProvider, useForm } from "react-hook-form";
import warning_blue from "../../../../assets/images/icons/warning_blue.svg";

import moment, { Moment } from "moment";
import { useTranslation } from "react-i18next";
import { GeneralButton, GeneralInput, Modal } from "../../../../components";

interface IAppointmentCancelConfirm {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data?: any) => void;
  appointmentDate?: string | Moment;
  status?: "Cancel" | "Reject";
  multiple?: boolean;
  isLoading?: boolean;
}

const AppointmentCancelConfirm: React.FC<IAppointmentCancelConfirm> = ({
  isOpen,
  onClose,
  onSubmit,
  appointmentDate,
  status,
  multiple,
  isLoading,
}) => {
  const methods = useForm({});

  const { t } = useTranslation();
  const { handleSubmit, reset, getValues } = methods;

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        reset(undefined);
        onClose();
      }}
    >
      <div className="flex flex-col items-center justify-center gap-6">
        <img className="mx-auto h-28 w-24" alt="warning" src={warning_blue} />
        <div className="flex flex-col items-center justify-center gap-2">
          {appointmentDate && (
            <div className="text-sm">
              {moment(appointmentDate).format("dddd DD, MMMM HH:mm")}
            </div>
          )}
          <div className="text-lg font-bold">
            {t(
              status === "Reject"
                ? "reject_appointment"
                : multiple
                  ? "cancel_appointments"
                  : "cancel_appointment",
            )}
            !
          </div>

          <div className="max-w-3/4 text-center text-body-text">
            {t(
              status === "Reject"
                ? "are_you_sure_you_want_to_reject_appointment"
                : multiple
                  ? "are_you_sure_you_want_to_cancel_selected_appointments"
                  : "are_you_sure_you_want_to_cancel_appointment",
            )}
          </div>
        </div>

        <FormProvider {...methods}>
          <form
            className="flex h-full w-full flex-col justify-between gap-6"
            onSubmit={handleSubmit(onSubmit)}
          >
            <GeneralInput
              customStyleClasses="!max-h-[6rem]"
              type="textarea"
              name="Note"
              placeholder={t(
                status === "Reject" ? "note" : "why_want_to_cancel_Appointment",
              )}
            />

            <div className="mx-auto flex w-3/4 items-center justify-center gap-2">
              <GeneralButton
                title={t("cancel_process")}
                color="lite"
                onClick={() => {
                  reset(undefined);
                  onClose();
                }}
                className="!w-1/2"
              />
              <GeneralButton
                title={t(
                  status === "Reject" ? "confirm_reject" : "confirm_cancel",
                )}
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  onSubmit(getValues());
                }}
                isLoading={isLoading}
                type="submit"
                color="red"
                className="!w-1/2"
              />
            </div>
          </form>
        </FormProvider>
      </div>
    </Modal>
  );
};

export default AppointmentCancelConfirm;
